import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { StaticsUpdatePage } from '../../statics-update/statics-update';

/**
 * Generated class for the HeaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-static-alert',
  templateUrl: 'static-alert.html',
})
export class StaticAlertPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {

  }

  openStaticsPage() {
    this.navCtrl.push(StaticsUpdatePage);
  }

  // this.path_analitycs/statics (pasar uid)

}



// WEBPACK FOOTER //
// ./src/pages/components/static-alert/static-alert.ts